import User from "../core/interfaces/User";
import { VanillaApiBadge, VanillaApiUser } from "../core/interfaces/VanillaApi";
import ProviderFactory from "../core/ProviderFactory";
import VanillaUsersProvider from "../core/providers/community/vanillaProviders/VanillaUsersProvider";
import {
  CommunityProviderType,
  ProviderConfiguration,
} from "../core/types/Provider";
import { isMode } from "../core/utilities";

export default abstract class UserModel {
  private static provider: VanillaUsersProvider = ProviderFactory.create(
    CommunityProviderType.Users,
    isMode("development")
      ? ProviderConfiguration.local
      : ProviderConfiguration.vanilla
  );
  private static currentUserCache: User = null;

  // public static getCurrentUserCached(): Promise<User> {
  //   return new Promise((resolve, reject) => {
  //     if (UserModel.currentUserCache === null) {
  //       UserModel.provider
  //         .getCurrentUser()
  //         .then((vanillaUser) => {
  //           const roles: Array<string> = [];
  //           const isAdmin = vanillaUser.permissions.some(
  //             (permission: string) => permission === "settings.view"
  //           );
  //           const isModerator = vanillaUser.permissions.some(
  //             (permission: string) => permission === "community.moderate"
  //           );
  //           isAdmin ? roles.push("ADMINISTRATOR") : "";
  //           isModerator ? roles.push("MODERATOR") : "";
  //           const user: User = {
  //             id: vanillaUser.userID,
  //             name: vanillaUser.name,
  //             roles: roles,
  //             photoUrl: vanillaUser.photoUrl,
  //             email: vanillaUser.email,
  //           };
  //           UserModel.currentUserCache = user;
  //           resolve(user);
  //         })
  //         .catch((error) => {
  //           reject(error);
  //         });
  //     } else {
  //       resolve(UserModel.currentUserCache);
  //     }
  //   });
  // }

  public static getCurrentUserCached(): Promise<User> {
    return new Promise((resolve, reject) => {
      if (UserModel.currentUserCache === null) {
        UserModel.provider
          .getCurrentUserFromJsonPage()
          .then((vanillaUser) => {
            const roles: Array<string> = [];
            const isAdmin = vanillaUser.UserRoles?.some((role: string) =>
              role.includes("Administrator")
            );
            const isModerator = vanillaUser.UserRoles?.some((role: string) =>
              role.includes("Moderator")
            );
            isAdmin ? roles.push("ADMINISTRATOR") : "";
            isModerator ? roles.push("MODERATOR") : "";
            const user: User = {
              id: vanillaUser.Profile?.UserID,
              name: vanillaUser.Profile?.Name,
              roles: roles,
              photoUrl: vanillaUser.Profile?.PhotoUrl,
              points: vanillaUser.Profile?.Points,
              currentRank: {
                rankID: vanillaUser.Rank?.RankID,
                name: vanillaUser.Rank?.Name,
                level: vanillaUser.Rank?.Level,
              },
            };
            UserModel.currentUserCache = user;
            resolve(user);
          })
          .catch((error) => {
            reject(error);
          });
      } else {
        resolve(UserModel.currentUserCache);
      }
    });
  }

  public static getUsersByName(keyword: string): Promise<Array<User>> {
    return new Promise((resolve, reject) => {
      UserModel.provider
        .getUsersByName(keyword)
        .then((vanillaUsers) => {
          const users: Array<User> = vanillaUsers.map(
            (user: VanillaApiUser) => {
              return {
                id: user.userID,
                name: user.name,
                roles: user.roles
                  ? user.roles.map((role) => role.name.toUpperCase())
                  : [],
                photoUrl: user.photoUrl,
                email: user.email,
              };
            }
          );
          resolve(users);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  public static getUserBadges(userId: number): Promise<Array<VanillaApiBadge>> {
    return new Promise((resolve, reject) => {
      UserModel.provider
        .getUserBadges(userId)
        .then((userBadges) => {
          resolve(userBadges);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
}
